const KEY = 'survey-skipped'
export const getIsSkippedSurveys = () => localStorage.getItem(KEY) === 'true'
export const setIsSkippedSurveys = (isSkipped: boolean) => localStorage.setItem(KEY, String(isSkipped))
export const removeIsSkippedSurveys = () => localStorage.removeItem(KEY)
